var productCardMarkup = 
  `<div class="row" id="product-grid">
  {{#products}} 
    <div class="product-item col-3 col-md-6 col_slide">
    <div class="snippet-product-grid">
      <div class="mobile_flex_row">
        <div class="grid-imagebox">
          <a href="{{du}}" class="product-link">
            <div class="product-images"><img src="{{iu}}" alt="product-image" width="500" height="657"></div>
          </a>
        </div>
        <div class="grid-meta row">
          <div class="left_information">
            <p class="product_title"><a href="{{du}}">{{dt}}</a></p>
            <div class="row align_center">
              <p class="product_price">{{cu}}{{pr}}</p>
            </div>
          </div>
          <div class="right_information">
            <p class="variant_title">{{option2}}</p>
            <button id="swym-remove-productBtn" aria-label="Delete" data-variant-id="{{epi}}" data-product-id="{{empi}}" class="removewishlist swym-delete-btn">
              <span class="wishlist-delete-text">
               remove
             </span>
            </button>
          </div>
        </div>
      </div>
      <div class="variants_options_main" data-product-id="{{empi}}" data-url="{{du}}" data-variant-id="{{epi}}" data-variant-name="{{vi}}">
      </div>
      <div class="btn_action {{#available}}hide_sold_out{{/available}}">
        {{#available}}
  		<button id="swym-custom-add-toCartBtn" data-state-cart="{{#isInCart}}swym-added{{/isInCart}}" data-product-url="{{du}}" data-variant-id="{{epi}}" data-product-id="{{empi}}" class="btn product-addcart swym-add-to-cart-btn swym-button swym-button-1 swym-is-button btn p_black w_100 center_align">
  			{{#isInCart}}Add to cart{{/isInCart}}{{^isInCart}}Add to cart{{/isInCart}}
  		</button>
        {{/available}}
        <button id="swym-custom-sold-out" class="button button-gray-border button-full">
            Sold Out
        </button>
     </div>
    </div>
  </div>
  {{/products}}
</div>`;
var variantModalMarkUp = `
    <div class="wishlist-sizedrawer" id="modal">
      <div class="modal-guts">
        {{#product.options}}
          <ul class="select-variant-{{name}} user-options grid-size-variants">
            {{#values}}
            <li class="sywm-radio">
			  <input type="radio" name="{{name}}" data-value="{{.}}" id="user-option{{.}}-{{product.id}}" >
              <label for="user-option{{.}}-{{product.id}}">{{.}}<span class="favourite-dots"></span></label>
            </li>
            {{/values}}
          </ul> 
        {{/product.options}}
      </div>      
    </div>`;
if (!window.SwymCallbacks) {
	window.SwymCallbacks = [];
}
window.SwymCallbacks.push(swymRenderWishlist); /* Init Here */

function swymRenderWishlist(swat) {
  // Get wishlist items
  swat.fetch(function(products) {
    //WishlistedProducts = structuredClone(products);
    console.log("products-->",products)
    WishlistedProducts = JSON.parse(JSON.stringify(products));
    for(let i = 0; i < WishlistedProducts.length; i++) {
      _swat.getProductDetails({
        du: WishlistedProducts[i].du,
        epi: WishlistedProducts[i].epi,
        empi: WishlistedProducts[i].empi
      },
      function(fullProductDetails) {
        for(let j = 0; j < fullProductDetails.variants.length; j++) {
          if(fullProductDetails.variants[j].id == WishlistedProducts[i].epi) {
           var colorname = fullProductDetails.variants[j].option2;
           WishlistedProducts[i].option2 = colorname;
            WishlistedProducts[i].available = fullProductDetails.variants[j].available;
          }
        }
        if(i == (WishlistedProducts.length -1 )){
            const editSchoolName = (jsonData) => {
              return jsonData.map(item => {
              var temp = Object.assign({}, item);
              var newDT = temp.dt.split("-")[0];
              var datavailable = fullProductDetails.available;
              temp.dt = newDT;
              return temp;
              });
            }
            var updatedSchools = editSchoolName(WishlistedProducts);
            console.log('updatedSchools',updatedSchools)
            var wishlistContentsContainer = document.getElementById("wishlist-items-container");
            var formattedWishlistedProducts = WishlistedProducts.map(function(p) {
            p = SwymUtils.formatProductPrice(p); // formats product price and adds currency to product Object
            p.isInCart = _swat.platform.isInDeviceCart(p.epi) || (p.et == _swat.EventTypes.addToCart);
            p.available = p.available;
            return p;
            });
            var productCardsMarkup = SwymUtils.renderTemplateString(productCardMarkup, {
              products: updatedSchools
            });
            if(wishlistContentsContainer){
              wishlistContentsContainer.innerHTML = productCardsMarkup;
              
              countWishlist();
              attachClickListeners();
              $('.grid-meta.row').matchHeight({ property: 'height' });
            } else{
            console.log("Container not found, Wishlist Page element not found");
            }
          }
      });
      
    }
 
  });

}
function attachClickListeners() {
  var AddVariants = document.querySelectorAll(".variants_options_main");
  // document.querySelectorAll(".sywm-radio input").addEventListener("change",function(evtt){
  //   console.log("parent",evtt)
  // })
  for (var i = 0; i < AddVariants.length; i++) {
    ShowVariants(AddVariants[i])
  }
  var removeBtns = document.querySelectorAll(".removewishlist");
    for (var k = 0; k < removeBtns.length; k++) {
      removeBtns[k].addEventListener('click', onRemoveBtnClick, false);
  }
  var addToCartButtons = document.querySelectorAll(".swym-add-to-cart-btn");
	//   Add to cart Btns
	for (var i = 0; i < addToCartButtons.length; i++) {
		addToCartButtons[i].addEventListener('click', onAddToCartClick, false);
	}
}
function onRemoveBtnClick(e) {
  e.preventDefault();
  var epi = +e.currentTarget.getAttribute("data-variant-id");
  var empi = +e.currentTarget.getAttribute("data-product-id");
  window._swat.fetch(function(products) {
    products.forEach(function(product) {
      if (epi && empi && product.epi == epi && product.empi == empi) {
        window._swat.removeFromWishList(product, function() {
          if (!window.SwymCallbacks) {
            window.SwymCallbacks = [];
          }
          window.SwymCallbacks.push(swymRenderWishlist);
        });
      }
    });
  });
}
function ShowVariants(evt) {
  completeProductJson = {};
  var productId = evt.getAttribute("data-product-id");
  var variantId = evt.getAttribute("data-variant-id");
  var variantTitle = evt.getAttribute("data-variant-name");
  var du = evt.getAttribute("data-url");
  var params = {
    du: du,
    empi: parseInt(productId),
    epi: parseInt(variantId)
  }
  
  variantButtonAttributes = {};
  variantButtonAttributes = params; 
  window._swat.getProductDetails(params, function(productJson) { 
	completeProductJson = productJson;
    productJson.du = du;
    renderModalUI(productJson,evt);
    var jsonvariantid = productJson.variants;
    let iiTitle;
    jsonvariantid.forEach(function(i,value){  
      
      if (i.available == false){
      
      if (i.title.includes('/')) {
      iiTitle = i.title.split(' / ')[1];
      } else {
      iiTitle = i.title;
      }
        $('.sywm-radio [data-value="'+iiTitle+'"]').prop('disabled',true);
      }
      var allvarName = i.title;
      if(allvarName == variantTitle){
        $('.sywm-radio [data-value="'+variantTitle+'"]').prop('checked',true);
        if(i.available==false){
          $('.mob-buttoncart').hide();
          $('.soldout-gray').show();
        }
      }
    });
  });
}
function renderModalUI(productJson,event) {
  var modalElem = event;
  var variantMarkUpTemplate = SwymUtils.renderTemplateString(variantModalMarkUp, {
    product: productJson
  });
  console.log("productJson-->",productJson.options,productJson.variants)
  modalElem.innerHTML = variantMarkUpTemplate;

   var varid = parseInt(event.getAttribute('data-variant-id'));
  var myjson = productJson.variants;
      var result = myjson.find(item => item.id === varid);
  attachModalEventListeners(event)
     event.querySelectorAll('input[type="radio"]').forEach(function(e,i){
          let attrname =  e.getAttribute('name') + varid;
          // let Changeid =  e.getAttribute('id').split(" ").join("")+'-'+varid;
          // let ChangeFor = e.nextElementSibling.getAttribute('for').split(" ").join("")+'-'+varid;
          e.setAttribute('name',attrname);
          // e.setAttribute('id',Changeid);
          // e.nextElementSibling.getAttribute('for',ChangeFor);
     })
      if(result.option1 != undefined){
          let para1 = event.querySelectorAll('.user-options')[0];
          para1.querySelector('input[data-value="'+ result.option1 +'"]').checked = true;
      }
        if(result.option2 != undefined){
          let para2 = event.querySelectorAll('.user-options')[1];
          para2.querySelector('input[data-value="'+ result.option2 +'"]').checked = true;
      }
        if(result.option3 != undefined){
          let para3 = event.querySelectorAll('.user-options')[2];
          para3.querySelector('input[data-value="'+ result.option3 +'"]').checked = true;
      }

  $('.select-variant-Size').matchHeight({ property: 'height' });
  
}
function attachModalEventListeners(event) {
  var saveButtons = event.querySelectorAll(".sywm-radio>input");
  for (var i = 0; i < saveButtons.length; i++) {
    saveButtons[i].addEventListener("change", function(e) {
      console.log(e,"--e")

        var paradiv = e.target.closest('.modal-guts');
        var mainpara = paradiv.closest('.variants_options_main');
        ShowVariants(mainpara)
        setTimeout(function() {
          saveSelection(e);      
        },100)
      
    });
  }
}
function saveSelection(event) {
  var paradiv = event.target.closest('.modal-guts');
  var SelectorMain = paradiv.querySelector(".user-options.select-variant-Size");
  var userSelectionData = getSelectTagValues(paradiv,SelectorMain);
  var variant = findVariant(userSelectionData);
  removeProductFromWishlist(variantButtonAttributes, function(removedProduct) {
    var newProductVariantAttributes = {
      empi: removedProduct.empi,
      epi: variant.id,
      du: removedProduct.du
    }
    addProductToWishlist(newProductVariantAttributes);
  });
}
function getSelectTagValues(paradiv,selector) {
  var userSelection = {};
  if (typeof selector !== "undefined") {
    var elemNode = selector;
    $(elemNode).each(function(e){
      var optionValue = $(this).find('input[type="radio"]:checked').data('value');
      console.log("optionValue-->",optionValue)
      var key = "option" + (e + 2);      
      var selectedValueObj = _defineProperty({}, key, optionValue.toString());
      if (SwymUtils) {
        SwymUtils.extendDefaults(userSelection, selectedValueObj);
      }
    });       
    return userSelection;
  } else {
    console.log("Invalid Option Selector");
  }
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function findVariant(userSelectedOption) {
  var keys = Object.keys(userSelectedOption).filter(function(key) {
    return userSelectedOption[key] !== null && userSelectedOption[key] !== undefined;
  });

  var match = completeProductJson.variants.find(function(variant){
    return keys.every(function(key, value) {
      return (variant[key] === userSelectedOption[key] && variant[value] === userSelectedOption[value]);
    });
  });
  return match;
}
function removeProductFromWishlist(old_product_variant, callback) {
  window._swat.removeFromWishList(old_product_variant, function(r) {
    console.log("Removing current Variant")
    callback(r);
  });
}
function addProductToWishlist(new_product_variant) {
  window._swat.addToWishList(new_product_variant, function(r) {
    renderWishlistUI();
  });
}
function renderWishlistUI() {
  _swat.fetch(function(products) {
    //console.log('Item',products);
    //WishlistedProducts = structuredClone(products);
    WishlistedProducts = JSON.parse(JSON.stringify(products));
    for(let i = 0; i < WishlistedProducts.length; i++) {
      _swat.getProductDetails({
        du: WishlistedProducts[i].du,
        epi: WishlistedProducts[i].epi,
        empi: WishlistedProducts[i].empi
      },
      function(fullProductDetails) {
        for(let j = 0; j < fullProductDetails.variants.length; j++) {
          //console.log("loop 2 started - " + j + " - " + fullProductDetails.variants[j]);
          if(fullProductDetails.variants[j].id == WishlistedProducts[i].epi) {
            //console.log("match found - " + fullProductDetails.variants[j].id);
            WishlistedProducts[i].available = fullProductDetails.variants[j].available;
          }
        } 
      });
    }
    setTimeout(function(e){      
      $('.swym-wishlist-image').each(function(e){        
        var this_imgsrc = $(this).attr('src');
        var new_src = this_imgsrc.replace('_620x620', '');
        $(this).attr('src',new_src);
      });

      var h3height = 0;
    $('.wrappr_tl_prc').each(function() {
    if(h3height < $(this).outerHeight()){
      h3height = $(this).outerHeight();
    };
  });
  $('.wrappr_tl_prc').height(h3height);
      
    },2000); 
    currentUserWishlist = [];
    var wishlistContentsContainer = document.getElementById("wishlist-items-container");
    currentUserWishlist = products;
    var formattedWishlistedProducts = WishlistedProducts.map(function(p) {
      p = SwymUtils.formatProductPrice(p); // formats product price and adds currency to product Object
      p.variantinfo = (p.variants ? getVariantInfo(p.variants) : "");
      p.isInCart = _swat.platform.isInDeviceCart(p.epi) || (p.et == _swat.EventTypes.addToCart);
      p.available = p.available;
      return p;
    });
    var productCardsMarkup = SwymUtils.renderTemplateString(productCardMarkup, {
      products: WishlistedProducts
    });
    wishlistContentsContainer.innerHTML = productCardsMarkup;
    attachClickListeners();
       window.SwymCallbacks.push(swymRenderWishlist);
  });
//  setTimeout(showSoldOut, 1000);
}
function onAddToCartClick(e) {
	e.preventDefault();
	var productId = e.currentTarget.getAttribute("data-product-id");
	var variantId = e.currentTarget.getAttribute("data-variant-id");
	var du = e.target.getAttribute("data-product-url");
	e.target.innerHTML = "Adding..";
	window._swat.replayAddToCart({
		empi: productId,
		du: du
	}, variantId, function(c) {
		e.target.innerHTML = "Add to Cart";
		e.target.setAttribute("data-state-cart", "swym-added");
      if(typeof load_cart == 'function'){
        load_cart();
        setTimeout(function(e){
          document.querySelector('body').classList.add('open-drawer');
        },500);
      }else{
        window.location.href = "/cart";
      }
	}, function(e) {
		console.log(e);
	});
}
function countWishlist(){
  window._swat.fetch( function(r) {
    $('.swym-wishlist-header-counter').html(r.length);
  });
}
$(window).resize(function() {
 $('.select-variant-Size').matchHeight({ property: 'height' });
$('.grid-meta.row').matchHeight({ property: 'height' });
  
})
